import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import NewsRoomContent from "./NewsRoomContent/NewsRoomContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const NewsRoom = () => {
  const { t } = useTranslation();

  return (
    <>
      <Seo title={t("newsEducation.newsRoom.seo.title")} description={t("newsEducation.newsRoom.seo.des")} path="/news" />
      <TitleFormat text={t("newsEducation.newsRoom.title")} />
      <NewsRoomContent />
    </>
  );
};

export default NewsRoom;
